/**
 * Public origin for secret links, QR Code, and sharing.
 * When VITE_PUBLIC_APP_URL is set (e.g. an ngrok URL), links use that host
 * even if the Vite dev server is running on http://localhost:3000.
 */
export function getPublicOrigin(): string {
  const raw = import.meta.env.VITE_PUBLIC_APP_URL
  if (typeof raw === 'string' && raw.trim() !== '') {
    return raw.trim().replace(/\/$/, '')
  }
  return typeof window !== 'undefined' ? window.location.origin : ''
}
